// ArChat I18N Constants
// Created: 17-03-2026 03:55:00
// Author: SIVOL® - Aldo Frias - Argentina

export const SUPPORTED_LANGUAGES_COUNT = 18;
